FBpermissions = ['email', 'instagram_manage_insights', 'instagram_basic', 'pages_read_engagement', 'pages_show_list', 'business_management']

function preventEmptyFormFields() {
  if(true){
    var hasError = false
    $('*[data-reqfield="fb"]').each(function( index ) {
      var val = $( this ).val();
      if(!$.trim(val)){
        hasError = true;
      }
    });
    return hasError;
  }
}

// manage_pages
window.openGuestPopupFB = function openGuestPopupFB() {
    if (preventEmptyFormFields()) {
        alert('You must fill in all the fields above')
        return;
    }
    fbClientId = $('.omniauth').data().fbid
    igClientId = $('.omniauth').data().igid
    fbRedirectUrl = $('.omniauth').data().fbredirecturl
    user_uuid = $('.user').data().uuid
    scope = $('.user').data().scope
    native_country = $.trim($("select[name='native_country'] option:selected").val())
    resident_country = $.trim($("select[name='resident_country'] option:selected").val())
    phone_number = $.trim($("input[id='phone_number']").val())
    state = { phone_number: phone_number, user_id: user_uuid, native_country: native_country, resident_country: resident_country, scope: scope, source: 'web' }
    serialized_state = JSON.stringify(state)
    window.location.href = 'https://www.facebook.com/v16.0/dialog/oauth?client_id=' + fbClientId + '&redirect_uri=' + fbRedirectUrl + '&response_type=code&scope=' + FBpermissions.join(',') + '&state=' + encodeURIComponent(serialized_state)
}

window.openGuestPopupFBRelog = function openGuestPopupFBRelog() {
    fbClientId = $('.omniauth').data().fbid
    igClientId = $('.omniauth').data().igid
    fbRedirectUrl = $('.omniauth').data().fbredirecturl
    user_uuid = $('.user').data().uuid
    scope = $('.user').data().scope
    state = { user_id: user_uuid, scope: scope, source: 'web' }
    serialized_state = JSON.stringify(state)
    window.location.replace('https://www.facebook.com/v16.0/dialog/oauth?client_id=' + fbClientId + '&redirect_uri=' + fbRedirectUrl + '&response_type=code&scope=' + FBpermissions.join(',') + '&state=' + encodeURIComponent(serialized_state))
}

window.openSignInPopupFB = function openSignInPopupFB() {
    fbClientId = $('.omniauth').data().fbid
    igClientId = $('.omniauth').data().igid
    fbRedirectUrl = $('.omniauth').data().fbredirecturl
    state = { scope: 'guest', entry_point: 'sign_in', source: 'web' }
    serialized_state = JSON.stringify(state)
    window.location.replace('https://www.facebook.com/v16.0/dialog/oauth?client_id=' + fbClientId + '&redirect_uri=' + fbRedirectUrl + '&response_type=code&scope=' + FBpermissions.join(',') + '&state=' + encodeURIComponent(serialized_state));
}
